import timestampedResources from './resourceTypes.json' with { type: 'json' };
export default timestampedResources;
